import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
// import { toast } from "react-toastify"
import Pagination from "react-js-pagination"
import { isEmpty } from "lodash"
// import Button from "components/common/Button"
import Text from "components/text"
import Panel from "components/panel"
// import { RESPONSE_MODAL_TYPES } from "constants/modal-types"
// import { useWallet } from "hooks/use-wallet"
import {
  getWalletTransactions,
  // getUserWalletNonce,
  // verifyWalletAddress,
  // showConfirmModal,
  // claimL2ETokens,
} from "store/user/actions"
import {
  formatDate,
  amountFormatter,
  checkParams,
  // formatAddress,
} from "helpers/util"
import "./index.scss"

const APTWallet = (props = {}) => {
  const dispatch = useDispatch()
  const [activePage, setActivePage] = useState(1)
  // const [isClaimingTokens, setIsClaimingTokens] = useState(false)
  const { userId } = useSelector((state) => state.authReducer)
  const { walletDetails, walletTransactions = {} } = useSelector(
    (state) => state.userReducer
  )
  // const {
  //   walletBalance,
  //   walletAddress,
  //   isWalletConnected,
  //   isVerifyingAddress,
  //   web3,
  //   loadWeb3Modal,
  //   logoutOfWeb3Modal,
  // } = useWallet()

  const balance = walletDetails?.balance
  // const userNonce = walletDetails?.nonce
  const transactions = walletTransactions?.data || []

  const fetchWalletTransactions = () => {
    let data = {
      pageNumber: `page=${activePage}`,
      rowsPerPage: `perpage=10`,
    }

    dispatch(getWalletTransactions({ userId: userId, data: checkParams(data) }))
  }

  const handlePageChange = async (pageNumber) => {
    await setActivePage(pageNumber)
    fetchWalletTransactions()
  }

  // const confirmClaimToken = () => {
  //   const address = formatAddress(walletAddress, 8, 6)

  //   const modalData = {
  //     modalType: RESPONSE_MODAL_TYPES.WARNING,
  //     header: "Claim L2E Tokens?",
  //     message: `The claimable ${amountFormatter(
  //       balance
  //     )} L2E tokens will be transferred to your registered wallet address ${address}`,
  //     confirmLabel: "Claim tokens",
  //     confirmAction: () => {
  //       setIsClaimingTokens(true)
  //       dispatch(getUserWalletNonce({ public_address: walletAddress }))
  //     },
  //   }
  //   dispatch(showConfirmModal(modalData))
  // }

  // const getSigningMessage = () => {
  //   return `I am ${walletAddress}, signing my one-time nonce: ${userNonce}`
  // }

  // const handleSigningDone = (address, signature) => {
  //   const payload = {
  //     public_address: address,
  //     message: getSigningMessage(),
  //     signature,
  //   }
  //   if (isClaimingTokens) {
  //     toast.success("L2E tokens transferred!")
  //     dispatch(claimL2ETokens(payload))
  //   } else {
  //     dispatch(verifyWalletAddress(payload))
  //   }
  // }

  // const handleSigningFailed = (err) => {
  //   console.error("Message signing failed: ", err)
  //   if (isClaimingTokens) {
  //     toast.success("Token claiming failed!")
  //   } else {
  //     toast.error("Message signature failed")
  //     logoutOfWeb3Modal()
  //   }
  // }

  // useEffect(() => {
  //   // Monitor changes to nonce
  //   if (userNonce && web3) {
  //     const signingMessage = getSigningMessage()

  //     web3.eth.personal.sign(
  //       web3.utils.fromUtf8(signingMessage),
  //       walletAddress,
  //       (err, signature) => {
  //         if (err) {
  //           handleSigningFailed(err)
  //         } else {
  //           handleSigningDone(walletAddress, signature)
  //         }
  //       }
  //     )
  //   }
  // }, [userNonce])

  return (
    <div className="apt-wallet">
      <Panel pad="40">
        <Text type="headline" text="APT Wallet" />
        <div className="balances-wrapper">
          <div className="balance-container">
            <div className="balance">
              <h3>{amountFormatter(balance)}</h3>
              <span>L2E Coins</span>
            </div>
            {/* <Button
              label="CLAIM"
              size="medium"
              disabled={!isWalletConnected}
              onClick={confirmClaimToken}
            /> */}
          </div>
          {/* <div className="balance-container">
            <div className="balance">
              <h3>{walletBalance.toFixed(4)}</h3>
              <span>
                {isVerifyingAddress
                  ? "Verifying..."
                  : isWalletConnected
                  ? formatAddress(walletAddress)
                  : "Disconnected"}
              </span>
            </div>
            {isWalletConnected && !isVerifyingAddress ? (
              <Button
                label="LOGOUT"
                size="mediun"
                onClick={logoutOfWeb3Modal}
              />
            ) : (
              <Button
                label="CONNECT"
                size="mediun"
                disabled={isVerifyingAddress}
                onClick={loadWeb3Modal}
              />
            )}
          </div> */}
        </div>
        {transactions && (
          <div className="transaction-list">
            <Text type="subtitle" text="All Transaction Details" />
            <table>
              <thead>
                <tr>
                  <td>Description</td>
                  <td>Date</td>
                  <td className="text-right">Coins</td>
                  <td className="text-right">Running Balance</td>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{transaction?.description}</td>
                      <td>
                        {formatDate(transaction?.created_at, "YYYY-MM-DD")}
                      </td>
                      <td className="text-right">
                        <p
                          className={
                            transaction?.type === "credit"
                              ? "success"
                              : "danger"
                          }
                        >
                          {transaction?.type === "credit" ? "+" : "-"}
                          {amountFormatter(transaction?.value, 0)} coins
                        </p>
                      </td>
                      <td>
                        {amountFormatter(transaction?.running_balance, 0)}
                      </td>
                    </tr>
                  )
                })}
                {isEmpty(transactions) && (
                  <tr className="no-transaction">
                    <td colSpan="4">No Transaction found.</td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <Pagination
              prevPageText="Prev"
              nextPageText="Next"
              hideFirstLastPages
              pageRangeDisplayed={5}
              activePage={activePage}
              itemsCountPerPage={6}
              totalItemsCount={transactions.count ? transactions.count : 0}
              onChange={handlePageChange}
              innerClass="card-pagination"
              itemClass="pagination-item"
              itemClassPrev="pagination-action"
              itemClassNext="pagination-action"
              disabledClass="action-disabled"
              activeClass="item-active"
            />
          </div>
        )}
      </Panel>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.userReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getWalletTransactions,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(APTWallet)
